import React from 'react'
import { useNavigate } from 'react-router-dom'

interface AccessDeniedOverlayProps {
  visible: boolean
  onDismiss?: () => void
}

export default function AccessDeniedOverlay({ visible, onDismiss }: AccessDeniedOverlayProps) {
  const navigate = useNavigate()
  if (!visible) return null
  const handleDismiss = () => {
    onDismiss?.()
    navigate('/login', { replace: true })
  }
  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 800,
        background: 'var(--navy)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: '40px 24px',
        animation: 'bIn .4s ease both',
      }}
    >
      <div
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 6,
          background: 'rgba(239,68,68,.12)',
          border: '1px solid rgba(239,68,68,.25)',
          borderRadius: 100,
          padding: '4px 12px',
          fontSize: 10,
          fontWeight: 600,
          letterSpacing: '1px',
          textTransform: 'uppercase',
          color: '#F87171',
          marginBottom: 18,
        }}
      >
        <div style={{ width: 5, height: 5, background: '#F87171', borderRadius: '50%' }} />
        Access denied
      </div>
      <h2
        style={{
          fontFamily: "'Playfair Display',serif",
          fontSize: 26,
          fontWeight: 500,
          color: 'var(--white)',
          lineHeight: 1.3,
          marginBottom: 10,
        }}
      >
        You do not have access to this.
      </h2>
      <p
        style={{
          fontSize: 13.5,
          color: 'rgba(255,255,255,.5)',
          lineHeight: 1.7,
          maxWidth: 340,
          margin: '0 auto 36px',
        }}
      >
        Your account has been deactivated. Contact your administrator if you believe this is an error.
      </p>
      <button
        type="button"
        onClick={handleDismiss}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 8,
          background: 'var(--gold)',
          color: 'var(--navy)',
          border: 'none',
          borderRadius: 13,
          padding: '13px 28px',
          fontSize: 14,
          fontWeight: 600,
          cursor: 'pointer',
          boxShadow: '0 4px 20px rgba(201,168,76,.3)',
          transition: 'all .2s',
        }}
      >
        Back to login
      </button>
    </div>
  )
}
